export default "__VITE_ASSET__DNPxK9$D__"